import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-7" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from './FormSection.vue';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import RolePermissionService from '@/classes/RolePermissionService';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route     = useRoute();
const loader    = ref(false)
const showError = ref(false)
const errorMsg  = ref(null)

const roleId = route.params.id as unknown as string;

const tabs: { name: string, count: number, href?: string, allowed: boolean }[] = [
    {
        name : 'Information',
        count: 0,
        href : '',
        allowed: true
    },
    {
        name : 'Permissions',
        count: 0,
        href : `/accounts/roles/permission/${roleId}`,
        allowed: true
    },
];

const role = ref({});

const fetchRole = () => {
    loader.value = true;

    RolePermissionService.showRole(roleId)
        .then((result: any) => {
            loader.value = false;
            role.value   = result.data.role;
        })
        .catch((error: any) => {
            loader.value    = false;
            showError.value = true;
            errorMsg.value  = error.response.data.message;

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

onMounted(() => { fetchRole() })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Role",
    "show-back": "",
    backUrl: "/accounts/roles"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, { role: role.value }, null, 8, ["role"])
      ])
    ]),
    _: 1
  }))
}
}

})